<template>
  <div class="language-key-container">
    <h4>{{ title }}</h4>

    <div
      v-for="(entry, index) in entries"
      :key="entry[0]"
      class="line"
    >
      <language-autocomplete
        :language="entry[0]"
        @languageSelected="(l) => updateLanguage(l, index)"
      />

      <md-field class="field">
        <md-textarea
          v-model="entry[1]"
          md-autogrow
        />
      </md-field>

      <md-icon @click.native="removeEntry(index)">
        clear
      </md-icon>
    </div>

    <div class="add-button-line">
      <md-button
        class="add-button md-icon-button md-raised md-primary"
        @click.native="addEntry()"
      >
        <md-icon>
          add
        </md-icon>
      </md-button>
    </div>
  </div>
</template>

<script>
import LanguageAutocomplete from "@/components/Forms/Fields/LanguageAutocomplete";

export default {
    name: "LanguageKeyForm",
    components: {
        LanguageAutocomplete
    },
    props: {
      title: { type: String, required: true },
      values: { type: Object, required: true },
    },
    data() {
        return {
            skipUpdate: false,
            entries: this.entriesFromProps()
        };
    },
    watch: {
        entries() {
              if (this.skipUpdate) {
                this.skipUpdate = false;
                return;
              }

              this.onUpdate();
        },
        values() {
          this.skipUpdate = true;
          this.entries = this.entriesFromProps();
        }
    },
    methods: {
        updateLanguage(language, index) {
            this.entries[index][0] = language;
            this.onUpdate();
        },
        removeEntry(index) {
            this.entries.splice(index, 1);
        },
        addEntry() {
            this.entries.push(["",""]);
        },
        onUpdate() {
            const returnValue = this.entries;
            this.$emit("update", Object.fromEntries(returnValue));
        },
        entriesFromProps() {
          const entries = Object.entries(this.$props.values);
          if (entries.length === 0) {
            entries.push(["", ""]);
          }

          return entries;
        }
    },
};
</script>

<style scoped lang="scss">
    .language-key-container {
        width: 100%;
        border: 2px #EEE solid;
        border-radius: 3px;

        display: flex;
        flex-direction: column;
        padding: 8px 8px;

        h4 {
            margin: 0 0 5px;
            font-size: 14px;
            line-height: 22px;
            text-transform: capitalize;
        }

        .line {
            display: inline-grid;
            grid-template-columns: 1fr 3fr 24px;
            column-gap: 10px;

            .md-field {
                margin-top: 0 !important;
                margin-bottom: 0 !important;
            }
        }

        .add-button-line {
            display: flex;
            justify-content: center;
            padding: 6px 0 0;

            .add-button {
              margin: 0;
            }
        }
    }

    @media only screen and (max-width: 500px) {
      .language-key-container {
        .line {
          display: flex;
          width: 100%;
          column-gap: 0;

          .md-field {
            margin: 0 8px 0 0;
            max-width: calc(50% - 8px - 12px);
          }
        }
      }
    }
</style>
